<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import { removeToken,getLanguage } from '@/utils/auth';
  export default {
    name: 'App',
    mounted() {
      if(getLanguage()) {
        if (getLanguage() == 1) {
        	this.$i18n.locale = 'zh-cn'
        } else {
        	this.$i18n.locale = 'en-us'
        }
      }
      document.title = this.$t('ICA')
    }
  }
</script>

<style>
/*
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  } */
</style>



// WEBPACK FOOTER //
// src/App.vue